import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "../css/main.scss";
import productData from "../Datas/productData";

function Main() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div className="main">
      <Header />
      <main className="home">
        <section className="hero">
          <h2 className="hero-title">
            The latest innovations from Rivergrove are here.
          </h2>
          <p className="hero-sub">
            Get ready for seamless 4K panorama views, new AI technology to help
            outdoor cameras spot fires, alarms that don’t play by the old rules,
            and more.
          </p>
          <div className="hero-actions">
            <Link onClick={toTop} to="/shop" className="btn primary">
              Shop Now
            </Link>
            <Link onClick={toTop} to="/about" className="btn">
              Learn More
            </Link>
          </div>
        </section>

        <section className="mosaic" aria-label="Showcase">
          <div className="tile video center">
            <video
              src="/main/main1.mp4"
              autoPlay
              muted
              loop
              playsInline
              aria-label="Showcase video"
            />
          </div>
        </section>

        <section className="categories">
          <div className="cat">
            <img src="/main/main2-1.png" alt="" />
            <Link onClick={toTop} to="/shop" className="cat-link">
              Doorbells
            </Link>
          </div>
          <div className="cat">
            <img src="/main/main2-2.png" alt="" />
            <Link onClick={toTop} to="/shop" className="cat-link">
              Cameras
            </Link>
          </div>
          <div className="cat">
            <img src="/main/main2-3.png" alt="" />
            <Link onClick={toTop} to="/shop" className="cat-link">
              Alarms and Sensors
            </Link>
          </div>
          <div className="cat">
            <img src="/main/main2-4.png" alt="" />
            <Link onClick={toTop} to="/shop" className="cat-link">
              Accessories
            </Link>
          </div>
        </section>

        <section className="featured">
          <h3 className="featured-title">Featured Products</h3>
          <p className="featured-sub">
            Outfit your home with some of Rartoria’s best sellers.
          </p>

          <div className="product-grid">
            {productData.map((p, idx) => {
              const price = Number(p.price);
              const badges =
                [
                  ["Best Seller"],
                  ["Best Seller", "Save €19"],
                  ["Retinal 2K", "Save €19"],
                  [],
                ][idx] || [];
              const hasOld = idx === 1 || idx === 2;
              const oldPrice = (price + 20).toFixed(2);

              return (
                <Link
                  to={`/shopDetails/${p.id}`}
                  className="card"
                  key={p.id}
                  onClick={toTop}
                >
                  <div className="card-badges">
                    {badges.map((b, i) => (
                      <span
                        className={
                          "chip " +
                          (b.includes("Save")
                            ? "chip--warning"
                            : b.includes("Retinal")
                            ? "chip--success"
                            : "chip--primary")
                        }
                        key={i}
                      >
                        {b}
                      </span>
                    ))}
                  </div>
                  <div className="card-media">
                    <img src={p.image} alt={p.name} />
                  </div>
                  <div className="card-body">
                    <h4 className="card-name">{p.name}</h4>
                    <div className="price">
                      <span className="price-now">€{price.toFixed(2)}</span>
                      {hasOld && <span className="price-old">€{oldPrice}</span>}
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </section>

        <section className="promos" aria-label="More from Rivergrove">
          <div className="promo-card">
            <div className="promo-media">
              <img src="/main/main3-1.jpg" alt="" />
            </div>
            <div className="promo-body">
              <h4 className="promo-title">Rivergrove Sensors</h4>
              <p className="promo-sub">
                The next revolution in home security is here.
              </p>
              <div className="promo-actions">
                <Link onClick={toTop} to="/shop" className="btn outline">
                  Pre-Order
                </Link>
              </div>
            </div>
          </div>

          <div className="promo-card">
            <div className="promo-media">
              <img src="/main/main3-2.jpg" alt="" />
            </div>
            <div className="promo-body">
              <h4 className="promo-title">
                Automatically deter with specific details.
              </h4>
              <p className="promo-sub">
                Enable your cameras to instantly ward off trespassers with
                identifying details.
              </p>
              <div className="promo-actions">
                <Link onClick={toTop} to="/about" className="btn">
                  Learn More
                </Link>
              </div>
            </div>
          </div>

          <div className="promo-card">
            <div className="promo-media">
              <img src="/main/main3-3.jpg" alt="" />
            </div>
            <div className="promo-body">
              <h4 className="promo-title">Help find lost dogs</h4>
              <p className="promo-sub">
                Search Party lets you bRartoria lost dogs home.
              </p>
              <div className="promo-actions">
                <Link onClick={toTop} to="/contact" className="btn">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="perks" aria-label="Benefits">
          <div className="perks-inner">
            <h3 className="perks-title">
              Straight from the inventors, directly to your door.
            </h3>
            <ul className="perks-list">
              <li className="perk">
                <div className="perk-icon" aria-hidden="true">
                  <svg width="32" height="32" viewBox="0 0 24 24">
                    <path
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      d="M3 7h12v10H3zM15 10h3l3 3v4h-6z"
                    />
                    <circle
                      cx="7"
                      cy="19"
                      r="2"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                    <circle
                      cx="17"
                      cy="19"
                      r="2"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                  </svg>
                </div>
                <div className="perk-body">
                  <h4>Free shipping and returns</h4>
                  <p>
                    Free shipping on all orders. Plus, get free 45-day returns —
                    longer than leading retailers.
                  </p>
                </div>
              </li>

              <li className="perk">
                <div className="perk-icon" aria-hidden="true">
                  <svg width="32" height="32" viewBox="0 0 24 24">
                    <circle
                      cx="12"
                      cy="12"
                      r="8"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M12 7v6l3 2"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                  </svg>
                </div>
                <div className="perk-body">
                  <h4>10% off select products</h4>
                  <p>
                    Save on new devices with your Rivergrove subscription.{" "}
                    <Link to="/terms" onClick={toTop}>
                      Terms and conditions
                    </Link>
                    .
                  </p>
                </div>
              </li>

              <li className="perk">
                <div className="perk-icon" aria-hidden="true">
                  <svg width="32" height="32" viewBox="0 0 24 24">
                    <rect
                      x="4"
                      y="4"
                      width="16"
                      height="12"
                      rx="2"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M2 20h20"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                  </svg>
                </div>
                <div className="perk-body">
                  <h4>Free 30-day Rivergrove Plan trial</h4>
                  <p>
                    Try advanced features with your device purchase.{" "}
                    <Link to="/about" onClick={toTop}>
                      Learn more
                    </Link>
                    .
                  </p>
                </div>
              </li>

              <li className="perk">
                <div className="perk-icon" aria-hidden="true">
                  <svg width="32" height="32" viewBox="0 0 24 24">
                    <circle
                      cx="12"
                      cy="7"
                      r="3"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M5 20c0-4 3-6 7-6s7 2 7 6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                    <path
                      d="M3 9h4M3 12h4M3 15h4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                    />
                  </svg>
                </div>
                <div className="perk-body">
                  <h4>Direct support from Rivergrove Experts</h4>
                  <p>
                    The Rivergrove app and our 24/7 phone support are available
                    in English, Spanish, and more.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </section>

        <section className="builder" aria-label="Build your system">
          <div className="builder-icon" aria-hidden="true">
            <svg width="40" height="40" viewBox="0 0 24 24">
              <circle
                cx="11"
                cy="11"
                r="7"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
              />
              <line
                x1="16.5"
                y1="16.5"
                x2="21"
                y2="21"
                stroke="currentColor"
                strokeWidth="1.8"
              />
            </svg>
          </div>
          <h3 className="builder-title">Build Your System</h3>
          <p className="builder-sub">
            Get quick recommendations for your home or business.
          </p>
          <Link onClick={toTop} to="/shop" className="btn primary">
            Try Product Finder
          </Link>
        </section>

        <section className="plans" aria-label="Rivergrove Protect Plans">
          <div className="plans-left" aria-hidden="true">
            <div className="phone">
              <div className="slides">
                <div className="slide">
                  <img src="/main/main4.jpg" alt="" />
                  <span className="month">MAR</span>
                </div>
              </div>
            </div>
          </div>

          <div className="plans-right">
            <div className="plans-head">
              <div className="plans-icon" aria-hidden="true">
                <svg width="28" height="28" viewBox="0 0 24 24">
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  />
                  <path
                    d="M8 12l2.5 2.5L16 9"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  />
                </svg>
              </div>
              <div>
                <h4 className="plans-title">Rivergrove Protect Plans</h4>
                <h3 className="plans-subtitle">
                  See more. Know more. Protect more.
                </h3>
              </div>
            </div>
            <p className="plans-copy">
              Subscribe to a compatible Protect Plan to rewatch moments you
              missed, unlock advanced AI recognition, get emergency monitoring,
              and more. You'll only pay for what you need.
            </p>

            <div className="accordions">
              <details className="acc" open>
                <summary>Up to 180 Days of Video History</summary>
                <div className="acc-body">
                  Save, share and replay recorded videos of every doorbell
                  Rivergrove, motion event, and Live View event for up to 180
                  days.
                </div>
              </details>

              <details className="acc">
                <summary>AI Video Descriptions</summary>
                <div className="acc-body">
                  Automatic descriptions add context to recordings for quicker
                  review.
                </div>
              </details>

              <details className="acc">
                <summary>
                  Familiar Faces<span className="beta">Beta</span>
                </summary>
                <div className="acc-body">
                  Helps your device recognize frequent visitors and send more
                  personalized alerts.
                </div>
              </details>

              <details className="acc">
                <summary>24/7 Professional Monitoring</summary>
                <div className="acc-body">
                  Optional monitoRartoria services for rapid response in
                  emergencies.
                </div>
              </details>

              <details className="acc">
                <summary>
                  AI Unusual Event Alerts<span className="beta">Beta</span>
                </summary>
                <div className="acc-body">
                  Get notified when your camera detects unusual activity
                  patterns.
                </div>
              </details>
            </div>
          </div>
        </section>

        {/* 5 */}
        <section className="promos promos--two" aria-label="Spotlights">
          <div className="promo-card">
            <div className="promo-media">
              <img src="/main/main5-1.jpg" alt="" />
            </div>
            <div className="promo-body">
              <h4 className="promo-title">Introducing Search Party</h4>
              <p className="promo-sub">
                Help lost dogs reunite with families using Rartoria’s Search
                Party feature.
              </p>
              <div className="promo-actions">
                <Link onClick={toTop} to="/about" className="btn primary">
                  Learn More
                </Link>
              </div>
            </div>
          </div>

          <div className="promo-card">
            <div className="promo-media">
              <img src="/main/main5-2.jpg" alt="" />
            </div>
            <div className="promo-body">
              <h4 className="promo-title">About Us</h4>
              <p className="promo-sub">
                Working every day to make neighborhoods safer.
              </p>
              <div className="promo-actions">
                <Link onClick={toTop} to="/about" className="btn primary">
                  Learn More
                </Link>
              </div>
            </div>
          </div>
        </section>

        <section className="footnotes" aria-label="Legal footnotes">
          <p className="fn-line">
            <span className="fn-num">1</span>
            Compatible{" "}
            <Link to="/subscribe" onClick={toTop} className="fn-link">
              Rivergrove subscription
            </Link>{" "}
            required. Your Rivergrove motion event videos in the cloud are
            stored, up to 180 days from recording. Modifying your video storage
            duration affects only recordings created after the change is
            applied.
          </p>
          <p className="fn-line">
            <span className="fn-num">2</span>
            Compatible{" "}
            <Link to="/subscribe" onClick={toTop} className="fn-link">
              Rivergrove subscription
            </Link>{" "}
            required. Features not available for customers in Illinois due to
            state-specific legislation. AI Unusual Event Alerts, Video
            Descriptions, and Single Event Alert availability limited to mobile
            devices with{" "}
            <Link to="/about" onClick={toTop} className="fn-link">
              select
            </Link>{" "}
            primary languages. AI Unusual Event Alerts part of AI Video
            Descriptions and may be impacted by the number of events and other
            device limitations.{" "}
            <Link to="/about" onClick={toTop} className="fn-link">
              Learn More
            </Link>
            .
          </p>
          <p className="fn-line">
            <span className="fn-num">3</span>
            Compatible{" "}
            <Link to="/subscribe" onClick={toTop} className="fn-link">
              Rivergrove subscription
            </Link>{" "}
            and{" "}
            <Link to="/about" onClick={toTop} className="fn-link">
              select
            </Link>{" "}
            devices required. Familiar Faces is not available for customers in
            Illinois, Texas, and Portland, Oregon due to specific legislation.
          </p>
          <p className="fn-line">
            <span className="fn-num">4</span>
            Compatible{" "}
            <Link to="/subscribe" onClick={toTop} className="fn-link">
              Rivergrove subscription
            </Link>{" "}
            is required to enroll in Professional Monitoring. Service available
            in all 50 U.S. states (territories not included) and in Canada
            (excluding Quebec). Rivergrove does not own its monitoRartoria
            center. Smoke and carbon monoxide monitoRartoria is not available
            for business or commercially zoned addresses. See Rivergrove Alarm
            licenses at:{" "}
            <Link onClick={toTop} to="/">
              www.rivergrove.blog
            </Link>
            . Additional fees may be required for permits, false alarms, or
            Alarm Verified Guard Response, depending on your local jurisdiction.
          </p>
        </section>

        {/* 6 */}
      </main>
      <Footer />
    </div>
  );
}

export default Main;
